/* v95.6 (16 Oct): Cash and Rusty move on every page. Each static cutout listed in RULES gets a keyed green-screen
   loop (pwgx-*.mp4 in Shopify Files) laid exactly over it. The still stays in the layout but goes invisible, so
   nothing shifts, and the loop follows the still's own motion (bobs, slide-ups) because it tracks its box every
   frame. Loops only play while on screen. No WebGL or reduced motion: the stills stay as they are.
   Side peek (sidePeek): Rusty peeks in from the right edge on About, Funny Corner and 404; Cash from the left on
   Oddly Rewarding. Once per page per session.
   Not touched here: corner pop-ups (pw-cast.js), homepage picks and open mic (pw-loop.js), About and Contact hero
   loops (pw-about.js), the 404 map, the email popup envelope, the footer sip and the price sticker (props or tiny). */
(function () {
  'use strict';
  /* v96: move the email pop-up to <body> so no header, dock or section layer can sit above it or clip its scrim */
  function lift() { var gt = document.getElementById('pw-gate'); if (gt && gt.parentNode !== document.body) document.body.appendChild(gt); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lift); else lift();
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var F = 'https://cdn.shopify.com/s/files/1/0888/1628/8064/files/pwgx-';
  /* selector, Rusty loop, Cash loop. Spread so one page never repeats a move. */
  var RULES = [
    ['.pwor__dog--rusty img', 'rusty-gasp', ''],
    ['.pwor__dog--cash img', '', 'cash-eyeroll'],
    ['.pwa-id__pic', 'rusty-tilt', 'cash-blink'],
    ['.pwa-doors__dog', 'rusty-sneeze', ''],
    ['.pwa-peek img', 'rusty-wiggle', ''],
    ['.pwc__success img', 'rusty-gasp', ''],
    ['.pwb-perch .pwb-masc', 'rusty-tilt', 'cash-blink'],
    ['.pw-cart__empty-art', 'rusty-guilty', ''],
    ['.pw-xsell__cash', '', 'cash-sideeye'],
    /* v96: the email pop-up's Rusty moves for real (whole-body wiggle) instead of a still */
    ['.pw-gate__art', 'rusty-wiggle', '']
  ];
  var VS = 'attribute vec2 p;varying vec2 u;uniform vec4 r;void main(){vec2 q=vec2(p.x*.5+.5,.5-p.y*.5);u=r.xy+q*r.zw;gl_Position=vec4(p,0.,1.);}';
  var FS = 'precision mediump float;varying vec2 u;uniform sampler2D t;void main(){vec4 c=texture2D(t,u);float m=max(c.r,c.b);float k=c.g-m;float a=1.-smoothstep(.10,.28,k);vec3 col=c.rgb;col.g=min(col.g,m+.04);gl_FragColor=vec4(col*a,a);}';
  function gl(cv) {
    var g = null;
    try { g = cv.getContext('webgl', { premultipliedAlpha: true, alpha: true }); } catch (e) {}
    if (!g) return null;
    function sh(t, s) { var o = g.createShader(t); g.shaderSource(o, s); g.compileShader(o); return o; }
    var pr = g.createProgram(); g.attachShader(pr, sh(g.VERTEX_SHADER, VS)); g.attachShader(pr, sh(g.FRAGMENT_SHADER, FS)); g.linkProgram(pr); g.useProgram(pr);
    var b = g.createBuffer(); g.bindBuffer(g.ARRAY_BUFFER, b); g.bufferData(g.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), g.STATIC_DRAW);
    var l = g.getAttribLocation(pr, 'p'); g.enableVertexAttribArray(l); g.vertexAttribPointer(l, 2, g.FLOAT, false, 0, 0);
    var tx = g.createTexture(); g.bindTexture(g.TEXTURE_2D, tx);
    g.texParameteri(g.TEXTURE_2D, g.TEXTURE_WRAP_S, g.CLAMP_TO_EDGE); g.texParameteri(g.TEXTURE_2D, g.TEXTURE_WRAP_T, g.CLAMP_TO_EDGE);
    g.texParameteri(g.TEXTURE_2D, g.TEXTURE_MIN_FILTER, g.LINEAR); g.texParameteri(g.TEXTURE_2D, g.TEXTURE_MAG_FILTER, g.LINEAR);
    g.__r = g.getUniformLocation(pr, 'r'); g.uniform4f(g.__r, 0, 0, 1, 1);
    return g;
  }
  /* the character's box on the first frame, as fractions [x, y, w, h] */
  function bbox(v) {
    try {
      var W = 72, H = 96, c = document.createElement('canvas'); c.width = W; c.height = H;
      var x = c.getContext('2d'); x.drawImage(v, 0, 0, W, H);
      var a = x.getImageData(0, 0, W, H).data, x0 = W, y0 = H, x1 = -1, y1 = -1;
      for (var y = 0; y < H; y++) for (var i = 0; i < W; i++) { var o = (y * W + i) * 4; if (a[o + 1] - Math.max(a[o], a[o + 2]) < 40) { if (i < x0) x0 = i; if (i > x1) x1 = i; if (y < y0) y0 = y; if (y > y1) y1 = y; } }
      if (x1 < 0) return null;
      x0 = Math.max(0, x0 - 2); y0 = Math.max(0, y0 - 2); x1 = Math.min(W - 1, x1 + 2); y1 = Math.min(H - 1, y1 + 1);
      return [x0 / W, y0 / H, (x1 - x0 + 1) / W, (y1 - y0 + 1) / H];
    } catch (e) { return null; }
  }
  function who(el) {
    var s = ((el.currentSrc || el.getAttribute('src') || '') + ' ' + (el.getAttribute('data-src') || '') + ' ' + el.className + ' ' + (el.parentNode && el.parentNode.className || '')).toLowerCase();
    if (s.indexOf('rusty') > -1 || /\bm1\b/.test(s)) return 'r';
    if (s.indexOf('cash') > -1 || /\bm2\b/.test(s)) return 'c';
    return '';
  }
  function attach(el, file) {
    if (el.__pw956) return; el.__pw956 = 1;
    var par = el.parentNode; if (!par) return;
    var cv = document.createElement('canvas'); cv.className = 'pw956-v'; cv.setAttribute('aria-hidden', 'true');
    var g = gl(cv); if (!g) return;
    var v = document.createElement('video');
    v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('muted', ''); v.crossOrigin = 'anonymous'; v.preload = 'auto';
    var raf = 0, on = false, box = null, placed = false;
    function place() {
      var r = el.getBoundingClientRect();
      if (!r.width || !r.height) { cv.style.display = 'none'; return false; }
      if (!placed) { if (getComputedStyle(par).position === 'static') par.style.position = 'relative'; par.appendChild(cv); placed = true; }
      var p = par.getBoundingClientRect();
      cv.style.display = 'block';
      cv.style.left = (r.left - p.left - par.clientLeft) + 'px'; cv.style.top = (r.top - p.top - par.clientTop) + 'px';
      cv.style.width = r.width + 'px'; cv.style.height = r.height + 'px';
      var z = getComputedStyle(el).zIndex; cv.style.zIndex = z === 'auto' ? '' : z;
      var d = Math.min(2, window.devicePixelRatio || 1), W = Math.round(r.width * d), H = Math.round(r.height * d);
      if (cv.width !== W || cv.height !== H) { cv.width = W; cv.height = H; }
      return true;
    }
    function draw() {
      if (!on) return;
      if (v.readyState >= 2) {
        if (!box) { box = bbox(v) || [0, 0, 1, 1]; g.uniform4f(g.__r, box[0], box[1], box[2], box[3]); el.classList.add('pw956-on'); }
        if (place()) {
          /* fit the character inside the still's box, feet on the bottom edge */
          var A = (box[2] * (v.videoWidth || 3)) / (box[3] * (v.videoHeight || 4)), W = cv.width, H = cv.height, dw = W, dh = W / A;
          if (dh > H) { dh = H; dw = H * A; }
          g.viewport(0, 0, W, H); g.clearColor(0, 0, 0, 0); g.clear(g.COLOR_BUFFER_BIT);
          g.viewport(Math.round((W - dw) / 2), 0, Math.round(dw), Math.round(dh));
          try { g.texImage2D(g.TEXTURE_2D, 0, g.RGBA, g.RGBA, g.UNSIGNED_BYTE, v); g.drawArrays(g.TRIANGLE_STRIP, 0, 4); } catch (e) { stop(); el.classList.remove('pw956-on'); cv.remove(); return; }
        }
      }
      raf = requestAnimationFrame(draw);
    }
    function start() { if (on) return; on = true; if (!v.src) v.src = F + file + '.mp4'; var q = v.play(); if (q && q.catch) q.catch(function () {}); draw(); }
    function stop() { on = false; cancelAnimationFrame(raf); v.pause(); }
    new IntersectionObserver(function (es) { es.forEach(function (e) { e.isIntersecting && !document.hidden ? start() : stop(); }); }, { rootMargin: '160px' }).observe(el);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); });
  }
  function scan() {
    RULES.forEach(function (rule) {
      document.querySelectorAll(rule[0]).forEach(function (el) {
        if (el.closest('#pw-cast')) return;
        var k = who(el), file = k === 'r' ? rule[1] : k === 'c' ? rule[2] : (rule[1] || rule[2]);
        if (file) attach(el, file);
      });
    });
  }
  /* side peek: once per page per session, Rusty pops in from the right edge (ears flop) and leaves; Cash does the same
     from the left on Oddly Rewarding. Only on the fun pages, never the homepage or product pages. */
  function sidePeek() {
    var p = location.pathname, file = '', side = 'right';
    if (/\/pages\/oddly-rewarding/.test(p)) { file = 'cash-peek'; side = 'left'; }
    else if (/\/pages\/about-us|\/collections\/funny-corner/.test(p) || document.querySelector('.pw404__img')) file = 'rusty-peek';
    if (!file) return;
    try { if (sessionStorage.getItem('pw956-peek' + p)) return; } catch (e) {}
    var fired = false;
    function go() {
      if (fired || document.hidden) return; fired = true;
      removeEventListener('scroll', onScroll);
      try { sessionStorage.setItem('pw956-peek' + p, '1'); } catch (e) {}
      var wrap = document.createElement('div'); wrap.setAttribute('aria-hidden', 'true');
      wrap.style.cssText = 'position:fixed;top:34vh;' + side + ':0;width:min(36vw,210px);aspect-ratio:3/4;z-index:30;pointer-events:none';
      var cv = document.createElement('canvas'); cv.width = 360; cv.height = 480; cv.style.cssText = 'width:100%;height:100%;display:block';
      wrap.appendChild(cv);
      var g = gl(cv); if (!g) return;
      var v = document.createElement('video');
      v.muted = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('muted', ''); v.crossOrigin = 'anonymous'; v.preload = 'auto';
      v.src = F + file + '.mp4';
      var raf = 0, shown = false;
      function tick() {
        if (v.readyState >= 2) {
          if (!shown) { document.body.appendChild(wrap); shown = true; }
          g.viewport(0, 0, cv.width, cv.height); g.clearColor(0, 0, 0, 0); g.clear(g.COLOR_BUFFER_BIT);
          try { g.texImage2D(g.TEXTURE_2D, 0, g.RGBA, g.RGBA, g.UNSIGNED_BYTE, v); g.drawArrays(g.TRIANGLE_STRIP, 0, 4); } catch (e) { end(); return; }
        }
        raf = requestAnimationFrame(tick);
      }
      function end() { cancelAnimationFrame(raf); v.pause(); wrap.remove(); }
      v.addEventListener('ended', end);
      var q = v.play(); if (q && q.catch) q.catch(end);
      tick();
      setTimeout(end, 9000);
    }
    function onScroll() { var h = document.documentElement; if ((scrollY + innerHeight) / h.scrollHeight > 0.35) go(); }
    /* v95.7: Oddly Rewarding already has Cash and Rusty in the hero, so Cash only peeks once the FAQ is on screen */
    var faq = side === 'left' && document.querySelector('.pwor__faq');
    if (faq && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); setTimeout(go, 600); } }, { threshold: 0.25 });
      io.observe(faq);
      return;
    }
    addEventListener('scroll', onScroll, { passive: true });
    setTimeout(go, 9000);
  }
  /* after the DOM is ready, so the FAQ can be found */
  function ready() { sidePeek(); scan(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
  /* the cart drawer and its cross-sell are filled in later */
  var t = 0;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 300); }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', scan);
})();
